/**
 * Static configuration options for the statistics dashboard
 */

// User type options
export const userTypeOptions = [
  { value: 'all', label: 'All Users' },
  { value: 'regular', label: 'Regular Users' },
  { value: 'technical', label: 'Technical Users' },
  { value: 'driver', label: 'Driver Users' }
];

// User activation period options
export const creationPeriodOptions = [
  { value: 'all', label: 'All Periods (Default)' },
  { value: 'week', label: 'Last Week' },
  { value: '2weeks', label: 'Last 2 Weeks' },
  { value: 'month', label: 'Last Month' }
];

// Cart type options
export const cartTypeOptions = [
  { value: 'all', label: 'All Carts' },
  { value: 'autonomous', label: 'Autonomous Carts' },
  { value: 'simulator', label: 'Simulator 100+ Carts' },
  { value: 'regular', label: 'Regular Driver Carts' },
  { value: 'active', label: 'In Active Pool Carts' }
];

// Trip status options
export const tripStatusOptions = [
  { value: 'success', label: 'Finished Successfully' },
  { value: 'failure', label: 'Failed Trips' }
];

// Trip type options
export const tripTypeOptions = [
  { value: 'PATH_TYPE_TRANSPORTATION_GOTOPICKUP', label: 'To Pickup' },
  { value: 'PATH_TYPE_TRANSPORTATION_GOTODEST', label: 'To Destination' },
  { value: 'PATH_TYPE_SHUTTLE_GOTO_START_POINT', label: 'Shuttle start point' },
  { value: 'PATH_TYPE_SHUTTLE_GOTO_DEST', label: 'Shuttle destination' }
];

export default {
  userTypeOptions,
  creationPeriodOptions,
  cartTypeOptions,
  tripStatusOptions,
  tripTypeOptions
};
